import { useSyncExternalStore } from 'react';

/**
 * U15 F5: modo simples do Portal. Desligado por padrão; a pessoa liga em Perfil. Fica no aparelho (`localStorage`, com
 * try/catch: o portal não tem preferência no banco) e esconde só o que é avançado no menu: Relatórios e a troca de empresas.
 * Nada perde o acesso por link.
 */
const CHAVE = 'malgo.portal.simples';
const EVENTO = 'malgo-portal-simples';

// Sem storage (janela privada, bloqueado), a escolha vale até recarregar.
let memoria = false;

export function modoSimplesLigado(): boolean {
  try {
    return localStorage.getItem(CHAVE) === '1';
  } catch {
    return memoria;
  }
}

export function definirModoSimples(ligado: boolean) {
  memoria = ligado;
  try {
    if (ligado) localStorage.setItem(CHAVE, '1');
    else localStorage.removeItem(CHAVE);
  } catch {
    /* sem storage: vale só até recarregar */
  }
  window.dispatchEvent(new Event(EVENTO));
}

function assinar(aviso: () => void) {
  window.addEventListener(EVENTO, aviso);
  window.addEventListener('storage', aviso);
  return () => {
    window.removeEventListener(EVENTO, aviso);
    window.removeEventListener('storage', aviso);
  };
}

export const useModoSimples = () => useSyncExternalStore(assinar, modoSimplesLigado, () => false);
